module.exports = __webpack_public_path__ + "img/image.7ac18514.png";